import React from 'react';

import Grid from '@mui/material/Grid';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';

import { useTranslation } from 'next-i18next';

// Components
import Typography from 'src/components/ui/Typography';
import Icon from 'src/components/ui/Icon';

// Data
import type { Ad } from 'src/types/__generated__/graphql';

// Constants
import { colours } from 'src/constants/colours';
import assetIcons from 'src/constants/assetIcons';
import { styledComponent } from 'src/utils/styled';

const StyledAvatar = styledComponent(Avatar)`
    border: 0.0625rem ${colours.borderGray} solid;
    padding: 0.75rem;
    &.MuiAvatar-root {
        width: 4rem;
        height: 4rem;
    }
    &.MuiAvatar-colorDefault {
        color: ${colours.black.main};
        background-color: ${colours.white.main};
    }

`;

interface Props {
    ad: Ad;
}

const Assets: React.FC<Props> = ({ ad }) => {
    const { t } = useTranslation(['create-ad', 'ad', 'common']);

    if (!ad.assets || ad.assets.length === 0) {
        return null;
    }

    return (
        <Grid spacing={4} container>
            {ad.assets.map((asset) => {
                const AssetIconName = assetIcons[String(asset)];
                return (
                    <Grid key={asset} display="flex" flexDirection="column" alignItems="center" item>
                        <Box mb={1}>
                            <StyledAvatar>
                                <Icon
                                    name={
                                        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
                                        AssetIconName ?? 'InfoCircle'
                                    }
                                    size="1.75rem"
                                />
                            </StyledAvatar>
                        </Box>
                        <Typography
                            variant="body1"
                            align="center"
                            data-target-id={`assets-${asset}`}
                            sx={{ fontSize: '0.875rem' }}
                        >
                            {t(`ad:assets.${asset}`)}
                        </Typography>
                    </Grid>
                );
            })}
        </Grid>
    );
};

export default Assets;
